import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute inset-0 w-full h-full z-1000"
}

import { computed } from "vue";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppLoading',
  setup(__props) {

const store = useStore();

const isLoadingActive = computed(() => {
  return store.getters["loading/isLoading"];
});

return (_ctx: any,_cache: any) => {
  return (isLoadingActive.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
        _createStaticVNode("<div class=\"flex items-center justify-center h-full min-h-full pt-4 px-4 pb-20 text-center sm:block sm:p-0\" data-v-23dc36e2><div class=\"absolute inset-0 bg-gray-100 bg-opacity-75 transition-opacity\" aria-hidden=\"true\" data-v-23dc36e2></div><span class=\"hidden sm:inline-block sm:align-middle sm:h-full\" aria-hidden=\"true\" data-v-23dc36e2>​</span><div class=\"inline-block align-middle overflow-hidden object-center transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6\" data-v-23dc36e2><div class=\"lds-ripple border-brand-main\" data-v-23dc36e2><div class=\"border-brand-main\" data-v-23dc36e2></div><div class=\"border-brand-main\" data-v-23dc36e2></div></div></div></div>", 1)
      ]))]))
    : _createCommentVNode("", true)
}
}

})